import { OrderForwardListItem } from "../../../../../../common/services/order-forward/list/order-forward-list";
import BillingsTaxiUnbilledTransferredOrderListingItem from "../types/billings-taxi-unbilled-transferred-order-listing-item";

const createListingItem = (
  responseDataItem: OrderForwardListItem,
): BillingsTaxiUnbilledTransferredOrderListingItem => {
  return {
    startDate: new Date(responseDataItem.startTime),
    transferDate: new Date(responseDataItem.forwardingTime),
    internalOrderId: responseDataItem.humanId,
    externalOrderId: responseDataItem.externalId,
    routeAddresses: responseDataItem.rideAddresses,
    passengers: responseDataItem.passengers,
    producerTaxi: responseDataItem.producer.name,
    consumerTaxi: responseDataItem.consumer.name,
    driversDisplayName: responseDataItem.driver,
    uuid: responseDataItem.id,
    readOnly: responseDataItem.readOnly,
  };
};

const createListingItems = (
  responseDataItems: OrderForwardListItem[],
): BillingsTaxiUnbilledTransferredOrderListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const billingsTaxiUnbilledTransferredOrderListingFactory = {
  createListingItems,
};

export default billingsTaxiUnbilledTransferredOrderListingFactory;
